import Vue from "vue";
import useSessionStorage from '../helpers/useSessionStorage'

class SystemService {

    get cacheKeys() {
        return {
            termsAndConditions: 'mo-terms-and-conditions'
        }
    }

    async pubConfigs() {
        try {
            return await Vue.axios.get("/pub-configs");
        } catch (e) {
            return Promise.reject(e);
        }
    }

    async getTermsAndConditions() {
        const { getSessionStorage, setSessionStorage } = useSessionStorage(systemService.cacheKeys.termsAndConditions);
        
        if(!getSessionStorage()) {
            try {
                const { data } = await Vue.axios.get("/get-terms-and-conditions");
                setSessionStorage(data);

                return data;
            } catch(e) {
                return Promise.reject(e);
            }
        }
        else {
            return getSessionStorage();
        }
    }
}

const systemService = new SystemService();

export default systemService;



// WEBPACK FOOTER //
// ./src/core/services/systemService.js